export default __webpack_public_path__ + "static/media/ic-clock.ace8746e.svg";